
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://btxpczvkiosaxdlfcuai.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ0eHBjenZraW9zYXhkbGZjdWFpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDAwNDYxNjcsImV4cCI6MjA1NTYyMjE2N30.xng4rtq_O82Vgf6yFPLmjO7H9tROBRS0dekg-ch2Uy0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
